import EventManager from "../../utils/services/eventManager.service";

interface IAppEvents {
  APP_SHOW: string;
  APP_HIDE: string;
}

export enum APP_EVENTS {
  APP_SHOW = "app_show",
  APP_HIDE = "app_hide",
  OUTLINE_SHOW = "outline_show",
  OUTLINE_HIDE = "outline_hide",
  FEATURE_SHOW = "feature_show",
  FEATURE_HIDE = "feature_hide",
  INTERIOR_SHOW = "interior_show",
  INTERIOR_HIDE = "interior_hide",
  FEATURES_COUNT_COMPLETE = "features_count_complete",
}

export class EventsManager {
  static instance: EventManager = new EventManager();
  static setup() {
    if (!EventsManager.instance) {
      EventsManager.instance = new EventManager();
    }

    for (const eventName in APP_EVENTS) {
      EventsManager.instance.registerEvent(
        APP_EVENTS[eventName as keyof IAppEvents]
      );
    }
  }
  static disconnet() {
    EventsManager.instance.disconnect();
  }
}
